import { IConfig } from '@cian/config/shared';

export const isChatsV2Enabled = (config: IConfig): boolean => {
  return Boolean(config.get<boolean>('frontend-chats.chatsV2.Enabled'));
};
